// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2HNqf","tab":"ProcedureTabs_tab__1FRtQ"};